import { useEffect, useRef } from 'react'

import { EMPTY_FUNCTION } from '../../../../constants/common'
import { EVENT_NAME_CLICK } from '../../../../constants/event'
import { isEventKeyEscape, stopPropagation } from '../../../../utils/events'
import { GRETA_AI_CHAT_CHAT_LIST_DRAWER_ID } from '../../GretaAIChat.constants'
import { useGretaAIChatContext } from '../../GretaAIChat.hooks'
import { focusFirstGretaAIChatChatListRow } from '../../GretaAIChat.utils'
import { GretaAIChatChatListColumn } from '../GretaAIChatChatListColumn'

import * as styles from './GretaAIChatChatListDrawer.module.css'

function GretaAIChatChatListDrawer({
  isPinned = false,
  isRowMenuOpen = false,
  toggleRef,
  onClose = EMPTY_FUNCTION,
  onMouseEnter = EMPTY_FUNCTION,
  onMouseLeave = EMPTY_FUNCTION,
  onSelectChat = EMPTY_FUNCTION,
}) {
  const drawerRef = useRef(null)
  const pinnedFocusDoneRef = useRef(false)

  const { chatListLoader } = useGretaAIChatContext()
  const chatCount = chatListLoader.chats.length

  useEffect(() => {
    function handleClickOutside(event) {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        onClose()
      }
    }

    const timerId = setTimeout(() => {
      document.addEventListener(EVENT_NAME_CLICK, handleClickOutside)
    })

    return () => {
      clearTimeout(timerId)
      document.removeEventListener(EVENT_NAME_CLICK, handleClickOutside)
    }
  }, [])

  useEffect(() => {
    if (isPinned) {
      if (!pinnedFocusDoneRef.current) {
        pinnedFocusDoneRef.current = focusFirstGretaAIChatChatListRow(
          drawerRef.current
        )
      }
    } else {
      pinnedFocusDoneRef.current = false
    }
  }, [chatCount, isPinned])

  function handleKeyDown(event) {
    if (
      isEventKeyEscape(event) &&
      !isRowMenuOpen &&
      drawerRef.current?.contains(event.target)
    ) {
      stopPropagation(event)
      toggleRef?.current?.focus()
      onClose()
    }
  }

  return (
    <aside
      className={styles.chatListDrawer}
      id={GRETA_AI_CHAT_CHAT_LIST_DRAWER_ID}
      ref={drawerRef}
      tabIndex={-1}
      onKeyDown={handleKeyDown}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <GretaAIChatChatListColumn
        withRowActions={false}
        onSelectChat={onSelectChat}
      />
    </aside>
  )
}

export default GretaAIChatChatListDrawer
